{
	"updateAvailable": "A new version of the app is available. Would you like to reload?",
	"updateTitle": "New Update",
	"updateButton": "Update",
	"mainPage": "Main Page",
	"home": "Home",
	"print": "Print",
	"buyer": "Buyer",
	"seller": "Seller",
	"submit": "Submit",
	"search": "Search",
	"newReq": "New Request",
	"detail": "Details",
	"confirm": "Confirm",
	"dragAndDrop": "Drag and drop files here to upload",
	"ton": "Ton",
	"accepted": "Accepted",
	"pending": "Pending",
	"complete": "Complete",
	"view": "View",
	"unknown": "Unknown",
	"section": "Section",
	"type": "Type",
	"acceptanceDate": "Acceptance Date",
	"ipAddress": "IP Address",
	"simpleAcceptance": "Simple Acceptance",
	"signatureRequired": "Signature Required",
	"errorLoadingData": "Error loading data",
	"SIDEBAR": {
		"DASHBOARD": "Dashboard",
		"TRADE": "Trade",
		"InboundGoods": "Inbound Goods",
		"inventory": "Inventory",
		"PORTFOLIO": "Portfolio",
		"ORDERS": "Order History",
		"StockWalletDetails": "Symbol History",
		"ALERTS": "Alerts",
		"ADMIN": "Administration",
		"profile": "Profile",
		"userManagement": "User Management",
		"legalUserManagement": "Legal Entity Request",
		"MoneyRequestManagement": "Financial Request Mgmt",
		"InboundGoodsRequest": "Warehousing Request",
		"baseInformation": "Basic Information",
		"stockSymbol": "Symbols",
		"goodsCategory": "Goods Classification",
		"releaseGoodsFromWarehousePriceConfig": "Outbound Config",
		"goodsToWarehousingPriceConfig": "Inbound Config",
		"labAnalysisPriceConfig": "Lab Analysis Config",
		"CHARGE_WALLET": "Wallet",
		"LAB_REPORTS": "Lab Reports",
		"moneyWallet": "Financial Reports",
		"trade": "Trades",
		"orders": "Orders",
		"warehouse": "Warehouse",
		"laboratory": "Laboratory",
		"report": "Reports",
		"goodsToWarehouse": "Inbound Requests",
		"goodsReleaseList": "Outbound Requests",
		"goodsCanceledList": "Canceled Goods List",
		"stockWalletDetails": "Symbol History",
		"warehouseManagement": "My Warehouse Mgmt",
		"agreementTemp": "Agreements & Contracts",
		"chat": "Messages",
		"elasticManagement": "Elasticsearch Management"
	},
	"elasticManagement": {
		"syncTitle": "Sync Data",
		"syncDesc": "Re-index all published ads into Elasticsearch",
		"syncBtn": "Start Sync",
		"syncSuccess": "Sync started successfully",
		"syncError": "Sync failed",
		"deleteTitle": "Delete Index",
		"deleteDesc": "Permanently clear all Elasticsearch index data",
		"deleteBtn": "Delete Index",
		"deleteSuccess": "Index deleted successfully",
		"deleteError": "Delete failed",
		"confirmMsg": "Are you sure you want to delete the entire Elasticsearch index?",
		"confirmHeader": "Confirm Delete",
		"confirmAccept": "Yes, delete",
		"confirmReject": "Cancel"
	},
	"agreement": {
		"details": {
			"title": "Agreement",
			"status": "Status"
		}
	},
	"report": {
		"moneyWallet": "Financial Reports",
		"orders": "Order Reports",
		"trade": "Trade Reports",
		"debtorCreditorDetails": "Details",
		"realTradeAmount": "Trade Cost (Excl. Fee)",
		"fees": "Fees",
		"vat": "VAT"
	},
	"DASHBOARD": {
		"STOCKS_TITLE": "Stocks",
		"PORTFOLIO_TITLE": "Portfolio",
		"CASH_BALANCE": "Cash Balance:"
	},
	"TABLE": {
		"SYMBOL": "Symbol",
		"COMPANY": "Company Name",
		"PRICE": "Price",
		"CHANGE": "Change",
		"VOLUME": "Volume",
		"SHARES": "Count",
		"AVG_BUY": "Avg Buy"
	},
	"PORTFOLIO": {
		"TITLE": "Portfolio",
		"TOTAL_VALUE": "Total Portfolio Value",
		"basedOnLastTradePrice": "Based on last trade price",
		"HOLDINGS": "Holdings",
		"SYMBOL": "Symbol",
		"QTY": "Quantity",
		"CURRENT_PRICE": "Current Price (Rial)",
		"VALUE": "Total Value (Rial)",
		"PNL": "P/L (Rial)",
		"CURRENCY": "Rial",
		"AVG_BUY_PRICE": "Avg Price (Rial)",
		"NEW": "New",
		"SINCE_LAST_VISIT": "Since last visit",
		"CARD_2_TITLE": "My Balance",
		"CARD_3_TITLE": "Blocked Balance",
		"CARD_4_TITLE": "Pending Approval",
		"showOldStockWallet": "Show old assets",
		"empty": "Your portfolio is empty"
	},
	"LAB_ANALYSIS": {
		"ID": "ID",
		"BUNDLE_CODE": "Bundle Code",
		"LABORATORY_NAME": "Laboratory Name",
		"ANALYSIS_TYPE": "Analysis Type",
		"STATUS": "Status",
		"RESULT": "Result",
		"CREATED_AT": "Created At",
		"UPDATED_AT": "Updated At"
	},
	"TRADE": {
		"TITLE": "Trades",
		"BALANCE": "Balance",
		"POSITIONS": "Your Positions",
		"SYMBOL": "Symbol",
		"QUANTITY": "Quantity",
		"AVG_PRICE": "Avg Price",
		"NEW_ORDER": "New Order",
		"BUY": "Buy",
		"SELL": "Sell",
		"QTY": "Qty",
		"LIMIT_PRICE": "Limit Price",
		"PLACE_ORDER": "Submit",
		"ORDERS": "Order History",
		"ID": "ID",
		"SIDE": "Side",
		"PRICE": "Price",
		"STATUS": "Status",
		"TIME": "Time",
		"FILLED": "Filled",
		"OPEN": "Open",
		"CANCELLED": "Cancelled",
		"DIRECTION": "{{dir}}",
		"PARTIALLY_FILLED": "Partially Filled"
	},
	"profile": {
		"title": "User Profile",
		"firstName": "First Name",
		"lastName": "Last Name",
		"email": "Email",
		"phone": "Phone Number",
		"language": "Language",
		"save": "Save Changes",
		"changeAvatar": "Change Avatar",
		"currentPassword": "Current Password",
		"newPassword": "New Password",
		"confirmPassword": "Confirm Password",
		"changePasswordBtn": "Change Password",
		"required": "This field is required",
		"passwordMinLength": "Password must be at least 6 characters",
		"passwordMismatch": "Passwords do not match",
		"infoTab": "User Info",
		"activeSessions": "Active Sessions",
		"passwordTab": "Change Password",
		"defaultReferral": "Default Referral Code",
		"shareReferralLink": "Share Invitation Link",
		"copy": "Copy",
		"registerInvitationCode": "Register Invitation Code",
		"invitationCode": "Enter invitation code",
		"sending": "Sending",
		"alreadyRegistered": "You have already registered.",
		"benefitTitle": "You have already registered.",
		"getRewardTitle": "How to get rewards",
		"invited": "Invited Users",
		"shareText": "Hi! Use this link to register on the site. It's an excellent and secure platform for trading non-ferrous metals:",
		"tabs": {
			"info": "User Info",
			"password": "Change Password",
			"activeSessions": "Active Sessions",
			"referral": "Referral Code"
		},
		"form": {
			"changeAvatar": "Change Avatar",
			"username": "Username",
			"email": "Email",
			"firstName": "First Name",
			"lastName": "Last Name",
			"identity": "National ID",
			"identityRequired": "National ID is required.",
			"phoneNumber": "Phone Number",
			"edit": "Edit"
		},
		"phoneDialog": {
			"title": "Verify Phone Number",
			"enterNewPhone": "Enter your new mobile number.",
			"send": "Send",
			"resend": "Resend Code!",
			"enterOTP": "Enter the sent code.",
			"confirm": "Confirm"
		},
		"common": {
			"acceptanceDate": "Acceptance Date",
			"ipAddress": "IP Address",
			"complete": "Signed",
			"view": "View",
			"confirmDelete": "Are you sure you want to delete?",
			"confirm": "Confirm",
			"cancel": "Cancel"
		},
		"termsAndAgreements": "Terms and Agreements",
		"terms": "Contracts",
		"agreements": "Agreements",
		"noAgreementsFound": "No agreements found"
	},
	"order": {
		"title": "My Orders",
		"newOrder": "New Order",
		"loading": "Loading orders...",
		"error": "Error loading orders",
		"id": "Order ID",
		"date": "Date",
		"statusHeader": "Status",
		"total": "Total (Rial)",
		"empty": "You haven't placed any orders yet",
		"selectedItemsLabel": "Selected Status Type",
		"selectedOrdersTypeLabel": "Selected Order Type",
		"fee": "Max Fee",
		"priceWithFee": "Total Price Incl. Fee",
		"amountYouWillReceive": "Total Receivable Incl. Fee",
		"statusMap": {
			"pending": "Pending",
			"shipped": "Shipped",
			"delivered": "Delivered",
			"cancelled": "Cancelled",
			"NEW": "In Queue",
			"PARTIALLY_FILLED": "Partially Filled",
			"CANCELED": "Canceled",
			"CANCELED_SELF_TRADE": "Self-Trade Rejected",
			"FILLED": "Filled",
			"REJECTED": "Rejected",
			"EXPIRED": "Expired",
			"PARTIALLY_CANCELED": "Canceled (Partially Filled)",
			"CANCELED_INSUFFICIENT_FUNDS": "Canceled (Insufficient Funds)"
		},
		"header": {
			"index": "#",
			"orderType": "Order",
			"symbol": "Symbol",
			"date": "Time",
			"status": "Status",
			"price": "Price (Rial)",
			"total": "Amount (Rial)",
			"quantity": "Qty",
			"fill_quantity": "Filled Qty",
			"orderer": "Orderer"
		},
		"action": {
			"delete": "Cancel",
			"deleteConfirmMsg": "Are you sure you want to cancel your order?",
			"confirm": "Confirm",
			"cancel": "Back"
		},
		"confirmOrder": {
			"header": "Confirm Order",
			"content": "Are you sure about your order details?",
			"marketOrderWarning": "Note: According to the agreement (to be implemented), in a Market order, your trade may be executed at any price available in the order book, and all responsibility lies with you.",
			"confirm": "Confirm & Submit",
			"cancel": "Cancel"
		}
	},
	"orderBook": {
		"count": "Count",
		"quantity": "Vol",
		"price": "Price",
		"labelBuy": "Buy Orders",
		"labelSell": "Sell Orders",
		"totalQuantity": "Total Vol",
		"buyTotalQuantity": "Buy Vol",
		"sellTotalQuantity": "Sell Vol",
		"selectPrice": "Click to select price"
	},
	"goodsCategory": {
		"title": "Goods Categories & Subcategories",
		"addNewCategory": "Add New Category",
		"name": "Name",
		"actions": "Actions",
		"edit": "Edit",
		"delete": "Delete",
		"addSub": "Add Subcategory",
		"addCategory": "Add Category",
		"cancel": "Cancel",
		"save": "Save",
		"subCategoryDetails": "Subcategory Details"
	},
	"goodsToWarehousing": {
		"title": "Warehouse Price Configuration",
		"addConfig": "Add New Configuration",
		"stockSymbol": "Stock Symbol",
		"price": "Price",
		"startDate": "Start Date",
		"endDate": "End Date",
		"isActive": "Is Active",
		"action": "Actions",
		"edit": "Edit",
		"delete": "Delete",
		"addConfigTitle": "Add Warehouse Price Config",
		"stockSymbolName": "Symbol Name (Type)",
		"priceLabel": "Price",
		"isConfigActive": "Is config active?",
		"cancel": "Cancel",
		"save": "Save",
		"validation": {
			"quantityRequired": "Quantity is required",
			"quantityMin": "Minimum must be 1"
		}
	},
	"labAnalysis": {
		"weightStatus": "Weighing",
		"bundleWeight": "Bundle Weight",
		"bundleLabel": "Bundle Label",
		"warehouseUnitTitle": "Unit",
		"converted": "Tokenized",
		"not_converted": "Not Tokenized",
		"title": "Lab Analysis Configuration",
		"addConfig": "Add Configuration",
		"stockSymbol": "Symbol",
		"price": "Price",
		"startDate": "Start Date",
		"endDate": "End Date",
		"isActive": "Is Active",
		"action": "Actions",
		"edit": "Edit",
		"delete": "Delete",
		"addConfigTitle": "Add Lab Analysis Config",
		"stockSymbolName": "Symbol Name",
		"priceLabel": "Price",
		"labExpertUser": "Lab Expert",
		"approvedStockSymbol": "Approved Symbol",
		"stockSymbolOwnerSelfDeclaration": "Owner Declared Symbol",
		"approved_true": "Approved",
		"approved_false": "Not Approved",
		"isConfigActive": "Config Active",
		"cancel": "Cancel",
		"save": "Save",
		"editTitle": "Edit Lab Analysis",
		"addTitle": "Register Lab Analysis",
		"analysisDate": "Analysis Date",
		"analysisReport": "Analysis Report",
		"approved": "Approved",
		"approvedQuantity": "Approved Qty",
		"selectStockSymbol": "Select Symbol",
		"uploadReportFile": "Upload Report File",
		"setUnit": "Assign Unit",
		"result": {
			"title": "Lab Analysis Result",
			"analysisDate": "Analysis Date",
			"result": "Result",
			"expertName": "Expert Name",
			"comments": "Comments",
			"confirm": "Confirm & Tokenize",
			"cancel": "Cancel"
		},
		"error": "An error occurred",
		"validation": {
			"quantityRequired": "Quantity is required",
			"quantityMin": "Quantity must be greater than zero",
			"analysisDateRequired": "Analysis date is required",
			"stockSymbolRequired": "Symbol selection is required",
			"analysisReportRequired": "Analysis report is required"
		},
		"status": {
			"PENDING": "Pending Determination",
			"CONVERTED": "Tokenized",
			"CANCELED": "Canceled"
		}
	},
	"releaseGoods": {
		"title": "Outbound Goods Price Config",
		"addConfig": "Add New Configuration",
		"stockSymbol": "Stock Symbol",
		"price": "Price",
		"setDeliverTime": "Set Delivery Time",
		"startDelivering": "Start Loading",
		"assignBundleNumber": "Enter Assigned Bundles",
		"delivered": "Delivered",
		"setDeliver": "Change status to Delivered",
		"startDate": "Start Date",
		"endDate": "End Date",
		"isActive": "Is Active",
		"action": "Actions",
		"edit": "Edit",
		"delete": "Delete",
		"addConfigTitle": "Add Outbound Price Config",
		"stockSymbolName": "Symbol Name (Type)",
		"priceLabel": "Price",
		"isConfigActive": "Is config active?",
		"cancel": "Cancel",
		"save": "Save",
		"warehousemanFullName": "Warehouseman",
		"bundlePlacement": "Bundle Location",
		"warehouseName": "Warehouse",
		"validation": {
			"quantityRequired": "Quantity is required",
			"quantityMin": "Minimum must be 1"
		},
		"status": {
			"REQ_RELEASE": "Release Requested",
			"ASSIGNED_DELIVER_TIME": "Exit Time Assigned",
			"LOADING_IN_WAREHOUSE": "Loading in Warehouse",
			"RELEASE_CANCELED": "Canceled",
			"DELIVERED": "Exited"
		}
	},
	"stockSymbolAdd": {
		"nameLabel": "Name",
		"nameRequired": "Company Name is required",
		"commentLabel": "Comments",
		"faUnitLabel": "Measurement Unit (Farsi)",
		"enUnitLabel": "Measurement Unit (English)",
		"minimumWeight": "Minimum Allowed Weight",
		"updateButton": "Update",
		"saveButton": "Save"
	},
	"stockSymbol": {
		"list": {
			"title": "Stock Symbols",
			"add": "Add Stock Symbol",
			"loading": "Loading...",
			"error": "Error loading data.",
			"header": {
				"index": "#",
				"name": "Name",
				"comment": "Description",
				"faUnit": "Farsi Unit",
				"enUnit": "English Unit",
				"status": "Status"
			},
			"status": {
				"ACTIVE": "Active (Tradable)",
				"TRADE_STOP": "Stopped",
				"TRADE_STOP_HIDE": "Stopped (Hidden)"
			}
		}
	},
	"wallet": {
		"charge": "Deposit",
		"moneyRequest": "Withdraw",
		"moneyWalletPayById": "Deposit via ID",
		"myBalance": "My Balance",
		"yourBalance": "Your Balance",
		"yourStockBalance": "Your Asset Balance",
		"insufficientFunds": "Insufficient funds.",
		"insufficientStock": "Insufficient assets.",
		"loadStockBalanceFailed": "Error loading balance",
		"loadingData": "Loading market data",
		"loadingStockBalance": "Loading your asset balance",
		"loadDataFailed": "Error loading balance",
		"paginatorReport": "Showing {first} to {last} of {totalRecords} entries",
		"LaboratoryFee": "Laboratory Fee",
		"StorageCost": "Storage Cost",
		"TotalCost": "Total Cost",
		"addCard": "Add Card",
		"description": "Description",
		"statusSelect": "Selected Status",
		"yourCards": "Your Cards",
		"selectCardPLZ": "Please select your card",
		"status": {
			"transaction": {
				"CREDIT": "Credit Increase",
				"CHARGE_ONLINE": "Online Top-up",
				"CHARGE_BANK_RECEIPT": "Bank Receipt Top-up",
				"REVERSE_BY_ADMIN": "Refund",
				"MONEY_REQUEST": "Withdrawal Request",
				"MONEY_REQUEST_FEE": "Withdrawal Fee",
				"BUY_STOCK": "Buy Stock",
				"SELL_STOCK": "Sell Stock",
				"BUY_STOCK_FEE": "Buy Fee",
				"SELL_STOCK_FEE": "Sell Fee",
				"GOODS_TO_WAREHOUSE_FEE": "Warehousing Fee",
				"GOODS_ANALYSIS_FEE": "Lab Analysis Fee",
				"RELEASE_FROM_WAREHOUSE": "Outbound Fee",
				"RELEASE_FROM_WAREHOUSE_FEE": "Outbound System Fee",
				"REFERRAL": "Referral Reward"
			},
			"payment": {
				"ACCEPTED": "Accepted",
				"BLOCKED": "Blocked",
				"REJECTED": "Rejected",
				"WAITING": "Waiting",
				"WAITING_BANK": "Waiting for Bank",
				"WAITING_FOR_ADMIN": "Waiting for Admin"
			}
		},
		"header": {
			"index": "#",
			"amount": "Total Amount (Rial)",
			"date": "Date",
			"transactionType": "Transaction Type",
			"status": "Status",
			"user": "Person",
			"resNum": "Deposit ID"
		},
		"chargeModal": {
			"title": "Wallet Top-up",
			"amountLabel": "Amount:",
			"cancel": "Cancel",
			"save": "Save"
		},
		"callback": {
			"verifying": "Verifying transaction, please wait...",
			"successTitle": "Payment Successful",
			"successMessage": "Your wallet has been successfully charged.",
			"backToWallet": "Back to Wallet",
			"failedTitle": "Payment Failed",
			"userCancelled": "Transaction was cancelled by you or encountered an error. If funds were deducted, they will be returned within 30 minutes to 72 hours.",
			"serverError": "Server error while verifying transaction.",
			"retry": "Retry"
		}
	},
	"inboundGoodsRequest": {
		"title": "Inbound Goods Request",
		"quantityInfo": "Quantity Information",
		"stockSymbolName": "Stock Symbol",
		"initialQuantity": "Initial Quantity",
		"bundleCount": "Bundle Count",
		"bundleWeight": "Bundle Weight (KG)",
		"driverInfo": "Driver Information",
		"driverName": "Driver Name",
		"driverMobile": "Driver Mobile",
		"driverCar": "Driver Car",
		"licensePlate": "License Plate",
		"deliveryComments": "Delivery Comments",
		"submit": "Submit Request",
		"reset": "Reset",
		"validation": {
			"quantityRequired": "Quantity is required",
			"quantityMin": "Minimum must be 1",
			"bundleCountRequired": "Bundle count is required",
			"bundleWeightRequired": "Bundle weight is required",
			"bundleWeightMin": "Must be greater than 0",
			"driverNameRequired": "Driver name is required",
			"mobileRequired": "Mobile number is required",
			"mobilePattern": "Please enter a valid mobile number",
			"carInfoRequired": "Car info is required",
			"licensePlateRequired": "License plate is required"
		}
	},
	"orderForm": {
		"stockSymbol": "Symbol",
		"selectStockPrompt": "Select a symbol.",
		"orderType": "Order Type",
		"transactionType": "Transaction Type",
		"trade_list": "Trade List",
		"noTradesFound": "No trades found",
		"buy": "Buy",
		"sell": "Sell",
		"quantity": "Qty",
		"price": "Price",
		"submit": "Submit",
		"paste": "Paste",
		"sending": "Sending...",
		"LIMIT": "Limit",
		"limit_info": "The order executes at your specified price or better. Execution speed depends on the set price.",
		"MARKET": "Market",
		"market_info": "The order executes instantly at the best market price. Final price may vary slightly due to volatility.",
		"marketOrderPriceNotice": "Best price automatically",
		"validation": {
			"quantityRequired": "Quantity is required",
			"quantityMin": "Quantity must be at least 1",
			"priceRequired": "Price is required",
			"priceMin": "Price must be positive"
		},
		"orderPlacedSuccessfully": "Order placed successfully!",
		"orderFailed": "Failed to place order. Please try again.",
		"readyToExecute": "Ready to execute",
		"notReadyToExecute": "Waiting for execution conditions",
		"insufficientFunds": "Insufficient funds",
		"insufficientStock": "Insufficient stock",
		"quickActions": "Quick Actions",
		"quickPresets": "Quick Presets",
		"priceShortcuts": "Price Shortcuts",
		"bestBid": "Best Bid",
		"bestAsk": "Best Ask",
		"lastPrice": "Last Price",
		"marketPrice": "Market Price",
		"orderPreview": "Order Preview",
		"previewOrder": "Preview Order",
		"orderSummary": "Order Summary",
		"stock": "Stock",
		"orderTypePreview": "Order Type",
		"quantityPreview": "Quantity",
		"pricePreview": "Price",
		"grossAmount": "Total Amount",
		"feeAmount": "Fee",
		"netAmount": "Net Amount",
		"currentMarketPrice": "Current Market Price",
		"priceImpact": "Price Impact",
		"executionProbability": "Execution Probability",
		"estimatedExecutionTime": "Est. Execution Time",
		"high": "High",
		"medium": "Medium",
		"low": "Low",
		"immediate": "Immediate",
		"confirmAndExecute": "Confirm & Execute",
		"editOrder": "Edit Order",
		"invalidOrder": "Invalid Order",
		"pleaseFillRequiredFields": "Please fill all required fields",
		"simulationNote": "This is a simulation based on current market conditions. Actual execution may differ.",
		"priceImpactNote": "Price impact shows how your order might affect the market price.",
		"executionProbabilityNote": "Based on current market depth and your order parameters.",
		"quickPresetApplied": "Quick preset applied",
		"quickPresetAppliedDetail": "Preset {{preset}} applied",
		"switchedToBuy": "Switched to Buy",
		"switchedToSell": "Switched to Sell",
		"marketOrderSelected": "Market Order Selected",
		"limitOrderSelected": "Limit Order Selected",
		"marketAnalysis": "Market Analysis",
		"seconds": "Seconds",
		"minutes": "Minutes",
		"hoursUncertain": "Hours/Uncertain",
		"market": "Market",
		"bid": "Bid",
		"ask": "Ask",
		"last": "Last",
		"useMarketPrice": "Use Market Price",
		"current": "Current"
	},
	"login": {
		"title": "Login",
		"username": "Username",
		"password": "Password",
		"submit": "Login"
	},
	"landing": {
		"title": "Welcome to Tada Metal Marketplace",
		"subtitle": "Please log in to access your dashboard",
		"login": "Login",
		"panel": "User Panel",
		"logout": "Logout",
		"aboutTitle": "About System",
		"aboutText": "This system helps companies and individuals manage trades, inventory, and compliance in real-time.",
		"contactTitle": "Contact Us",
		"contactEmail": "Support Email"
	},
	"roles": {
		"LEGAL": "Legal Entity",
		"REAL": "Real Person",
		"TRADER": "Trader",
		"WHMAN": "Warehouse Manager",
		"LAB": "Lab Manager",
		"LABMAN": "Lab Manager",
		"ADMIN": "System Admin",
		"USER": "User",
		"CLINIC_ADMIN": "Clinic Admin",
		"SALON_ADMIN": "Salon Admin",
		"SUPER_ADMIN": "Super Admin",
		"TRAINEE_USER": "Trainee",
		"TRAINER_USER": "Trainer",
		"SELLER_USER": "Seller",
		"traderDesc": "Track your trades, portfolio, and orders live.",
		"warehouseDesc": "In TadaPlus, the warehouseman plays a key role in the trade chain, responsible for receiving, storing, and managing metal inventory (esp. Zinc). After a trade, the warehouseman receives the metal according to specs, stores it standardly, and delivers it to the buyer on time. This ensures the health, authenticity, and security of traded goods.",
		"labDesc": "In TadaPlus, the laboratory guarantees the quality and authenticity of traded metals. Upon warehouse entry, experts sample and analyze the metal's technical specs and chemical composition. This confirms the seller's claim and assures buyers of quality.",
		"bannerDesc": "TadaPlus is a modern platform for facilitating transparent metal trading in the domestic market, starting with Zinc. It enables online order placement, supply/demand matching, and trade management. TadaPlus aims to create a transparent, competitive, and efficient market and plans to expand to other metals soon.",
		"adminDesc": "User management, settings, and full system control.",
		"LABORATORY": "Laboratory",
		"more": "More"
	},
	"signup": {
		"title": "Create Account",
		"name": "Full Name",
		"email": "Email",
		"password": "Password",
		"submit": "Sign Up",
		"createAccountLink": "Don't have an account? Sign up",
		"errors": {
			"nameRequired": "Name is required",
			"emailInvalid": "Invalid email",
			"passwordShort": "Password must be at least 6 characters"
		}
	},
	"adminDashboard": {
		"tradingVolume": "Trading Volume",
		"totalTraders": "Total Traders",
		"warehouseStock": "Warehouse Stock",
		"labPending": "Pending Lab Tests",
		"item": "Item",
		"quantity": "Quantity"
	},
	"footer": {
		"rights": "All rights reserved.",
		"backToTop": "Back to Top",
		"accessibility": "Accessibility",
		"contact us": "Contact Us",
		"customer service": "Customer Service"
	},
	"app": {
		"title": "BEAUTYBOSS",
    "description": "The first AI assistant for the beauty industry"
  },
	"aboutUs": {
		"title": "About Us",
		"description": "We are a leading stock trading platform providing real-time analytics and a secure experience for traders, managers, and users."
	},
	"contactUs": {
		"title": "Contact Us",
		"name": "Name",
		"email": "Email",
		"message": "Message",
		"send": "Send Message",
		"phoneNumber": "Phone Number"
	},
	"laboratory": {
		"management": "Lab Management",
		"title": "Lab Name",
		"item": "Item",
		"quantity": "Quantity",
		"evaluation": "Evaluation",
		"symbol": "Symbol",
		"evaluate": "Evaluate",
		"formTitle": "Lab Form",
		"code": "Lab Code",
		"assignLabExpert": "Assign Lab Expert",
		"active": "Active",
		"inactive": "Inactive",
		"selectIsActive": "Select Active Status",
		"stockSymbols": "Stock Symbols",
		"selectStockSymbols": "Select Stock Symbols",
		"expanded": {
			"labExperts": "Experts for {{lab}}: ",
			"emptyMessage": "No experts found for {{lab}}"
		}
	},
	"warehouse": {
		"management": "Warehouse Management",
		"detailsOfGoodsRelease": "Goods Release Details",
		"shed": {
			"title": "Shed",
			"addTitle": "Add Shed",
			"editTitle": "Edit Shed",
			"code": "Code"
		},
		"addShed": "Build Shed",
		"deleteShed": "Delete Shed",
		"editShed": "Edit Shed",
		"corridor": {
			"title": "Corridor",
			"addTitle": "Build Corridor",
			"editTitle": "Edit Corridor",
			"code": "Code"
		},
		"addCorridor": "Build Corridor",
		"label": "Label",
		"unitContent": "Bundles in Unit",
		"emptyUnitContent": "No goods in unit",
		"selectedWeight": "Withdrawn Weight",
		"unit": {
			"title": "Unit",
			"code": "Code",
			"storageCapacity": "Capacity",
			"currentOccupancy": "Used Capacity",
			"totalArea": "Total Area",
			"usableArea": "Usable Area",
			"addTitle": "Build Unit",
			"editTitle": "Edit Unit",
			"move": "Move Unit"
		},
		"title": "Warehouse Name",
		"code": "Warehouse Code",
		"item": "Item",
		"volume": "Volume",
		"owner": "Owner",
		"manage": "Manage",
		"warehouseStatus": "Warehouse Status",
		"address": {
			"legend": "Warehouse Address",
			"street": "Street",
			"city": "City",
			"state": "State",
			"postalCode": "Postal Code",
			"postalCodeWrong": "Incorrect Postal Code.",
			"country": "Country",
			"detail": "Address Details"
		},
		"totalArea": "Total Area",
		"usableArea": "Usable Area",
		"status": "Status",
		"assignLabExpert": "Assign Lab Expert",
		"establishedDate": "Established Date",
		"lastInventoryDate": "Last Inventory Date",
		"storageCapacity": "Storage Capacity",
		"currentOccupancy": "Current Occupancy",
		"goodsCategoryList": "Goods Categories",
		"goodsSubCategoryList": "Goods Subcategories",
		"selectGoodsCategories": "Select Categories",
		"selectGoodsSubCategories": "Select Subcategories",
		"selectWarehouseman": "Select Warehouseman",
		"validators": {
			"usableBiggerThanTotal": "Total area must be greater than or equal to usable area."
		},
		"expanded": {
			"warehouseman": "Warehousemen for {{warehouse}}: ",
			"emptyMessage": "No warehouseman found for {{warehouse}}"
		},
		"statusList": {
			"ACTIVE": "Active",
			"INACTIVE": "Inactive",
			"UNDER_MAINTENANCE": "Under Maintenance"
		},
		"outbound": {
			"selectedItemName": "Selected item for warehouse exit:",
			"maxExitVolume": "Max release volume:",
			"ninetyFivePercentTooltip": "Due to the error margin of existing ingots, the maximum release volume is 95% of your assets.",
			"warehouseInventory": "Warehouse Inventory:",
			"selectWarehouse": "Select Warehouse",
			"noWarehouseFound": "No warehouse holds the requested item.",
			"dialogTitle": "Goods Exit Form",
			"exitVolumeLabel": "Exit Volume",
			"maxCapacityError": "You can withdraw a maximum of 95% of your balance.",
			"requiredCost": "Required Cost:",
			"insufficientBalance": "Insufficient Balance",
			"quantityExceedsWarehouse": "Requested quantity exceeds warehouse stock.",
			"continue": "Continue"
		}
	},
	"user": {
		"title": "User Management",
		"userType": "Real/Legal",
		"identity": "National ID",
		"createdDate": "Registration Date",
		"firstName": "First Name",
		"lastName": "Last Name",
		"username": "Username",
		"mobileNumber": "Mobile Number",
		"address": "Address",
		"gender": "Gender",
		"role": "Role",
		"filterRole": "Filter by Role",
		"email": "Email",
		"all": "All",
		"selectRoles": "Select Roles",
		"selectUserType": "Select User Type",
		"shahkar": "Shahkar Verification",
		"paginatorReport": "Showing {first} to {last} of {totalRecords} entries",
		"addUser": "Add New User",
		"editUser": "Edit User",
		"changeStatus": "Change Status",
		"blockConfirmTitle": "Block user",
		"blockConfirmText": "Are you sure you want to block this user?",
		"unblockConfirmTitle": "Unblock user",
		"unblockConfirmText": "Are you sure you want to unblock this user?",
		"blockSuccess": "User blocked successfully",
		"unblockSuccess": "User unblocked successfully",
		"header": {
			"index": "#",
			"identity": "National ID",
			"firstName": "Name",
			"lastName": "Surname",
			"mobileNumber": "Mobile",
			"role": "Role",
			"actions": "Actions"
		}
	},
	"genders": {
		"MALE": "Male",
		"FEMALE": "Female",
		"OTHER": "Other"
	},
	"validation": {
		"nationalCode": "National Code must be 10 digits",
		"mobile": "Mobile must start with 09 and have 11 digits",
		"identity": "Please enter a valid National ID.",
		"mobileNumber": "Please enter a valid mobile number.",
		"email": "Please enter a valid email address."
	},
	"add": "Add",
	"back": "Back",
	"update": "Update",
	"reset": "Clear",
	"edit": "Edit",
	"delete": "Delete",
	"select": "Select",
	"actions": "Actions",
	"save": "Save",
	"excel": "Excel",
	"block": "Block",
	"unblock": "Unblock",
	"cancel": "Cancel",
	"filters": {
		"username": "Please enter the username",
		"searchTerm": "Enter username",
		"startDate": "From Date",
		"endDate": "To Date",
		"fromAmount": "From Amount",
		"toAmount": "To Amount",
		"fromQuantity": "Qty From",
		"toQuantity": "Qty To",
		"birthDate": "Birth Date",
		"status": "Status"
	},
	"activeDevices": {
		"expandAll": "Expand All",
		"collapseAll": "Collapse All",
		"kick": "Kick Out",
		"header": {
			"index": "#",
			"device": "Device",
			"os": "OS",
			"osVersion": "OS Version",
			"current": "Current",
			"mobile": "Mobile",
			"lastAccess": "Last Access"
		},
		"boolean": {
			"yes": "Yes",
			"no": "No"
		},
		"expanded": {
			"sessionsFor": "Sessions for {{device}}",
			"header": {
				"index": "#",
				"ip": "IP",
				"browser": "Browser",
				"started": "Started",
				"lastAccess": "Last Access",
				"expires": "Expires"
			},
			"emptyMessage": "No sessions for this device."
		}
	},
	"topbar": {
		"calendar": "Calendar",
		"messages": "Messages",
		"profile": "Profile",
		"swichLang": "Switch Language"
	},
	"messageService": {
		"add": {
			"success": "Created successfully",
			"error": "Creation failed"
		},
		"update": {
			"success": "Updated successfully",
			"error": "Update failed"
		},
		"delete": {
			"success": "Deleted successfully",
			"error": "Delete failed"
		}
	},
	"agreementTemplates": {
		"title": "Agreement Templates",
		"addNew": "Add New Template",
		"edit": "Edit Template",
		"delete": "Delete Template",
		"loading": "Loading...",
		"empty": "No agreement templates found",
		"form": {
			"title": "Title",
			"sectionKey": "Section Key",
			"agreementType": "Agreement Type",
			"content": "Content",
			"active": "Active",
			"newTemplate": "New Agreement Template",
			"editTemplate": "Edit Template"
		},
		"agreementTypes": {
			"SIMPLE_ACCEPTANCE": "Simple Acceptance",
			"SIGNATURE_REQUIRED": "Signature Required"
		},
		"validation": {
			"titleRequired": "Title is required",
			"sectionKeyRequired": "Section Key is required",
			"contentRequired": "Content is required"
		},
		"actions": {
			"save": "Save",
			"cancel": "Cancel"
		},
		"messages": {
			"createSuccess": "Agreement template created successfully",
			"createError": "Failed to create agreement template",
			"updateSuccess": "Agreement template updated successfully",
			"updateError": "Failed to update agreement template",
			"deleteSuccess": "Agreement template deleted successfully",
			"deleteError": "Failed to delete agreement template",
			"deleteConfirm": "Are you sure you want to delete this template?",
			"validationError": "Please fill all required fields",
			"loadError": "Failed to load agreement templates"
		},
		"table": {
			"title": "Title",
			"sectionKey": "Section Key",
			"agreementType": "Agreement Type",
			"active": "Active",
			"actions": "Actions"
		}
	},
	"goodsToWarehouse": {
		"trackingNumber": "Tracking Number",
		"owner": "Owner",
		"goodsSubCategory": "Subcategory",
		"warehouse": "Warehouse",
		"warehouseman": "Warehouseman",
		"initialQuantity": "Total Weight",
		"remainedQuantity": "Remaining Weight",
		"bundleCount": "Bundle Count",
		"bundleWeight": "Bundle Weight",
		"status": "Status",
		"requestDate": "Request Date",
		"receivedDate": "Received Date",
		"scheduledDateToDeliverInWarehouse": "Scheduled Delivery Date",
		"goodsToWarehousingPrice": "Warehousing Cost",
		"labAnalysisPrice": "Lab Analysis Cost",
		"driverName": "Driver Name",
		"driverMobile": "Driver Mobile",
		"driverCar": "Driver Car",
		"licensePlate": "License Plate",
		"deliveringCommentsFromRequester": "Requester Comments",
		"deliveringCommentsFromWarehouseman": "Warehouseman Comments",
		"assignedLaboratory": "Assigned Laboratory",
		"approvedQuantity": "Approved Qty",
		"approveWeight": "Confirm Weight",
		"approveWeightConfirmation": "Are you sure you want to confirm the weight?",
		"updateWeightSuccessMessage": "Weight confirmed successfully",
		"setWarehouse": "Assign Warehouse",
		"assignLaboratory": "Assign Laboratory",
		"assignDeliveryTime": "Assign Delivery Time",
		"assignLabAnalysis": "Register Lab Results",
		"receivedInWarehouse": "Received Time at Warehouse",
		"setWarehouseDialogHeader": "Assign Warehouse",
		"assignDeliverTimeDialogHeader": "Assign Delivery Time",
		"receivedInWarehouseDialogHeader": "Received Time at Warehouse",
		"labAnalysisResult": "View Lab Results",
		"goodsBundleLabAnalysis": "Register Lab Results",
		"goodsBundleLabAnalysisResult": "Lab Results",
		"seeGoodsBundleLabAnalysisResult": "View Lab Results",
		"updateDriverInformation": "Edit Driver Info",
		"delete": "Delete",
		"labAnalysisMismatch": "Resolve Mismatch",
		"assignUnitToBundle": "Weigh Bundles",
		"statusList": {
			"NEW": "New Request",
			"REQ_WAREHOUSED": "Warehousing Request",
			"ASSIGNED_DELIVER_TIME": "Delivery Time Assigned",
			"DELIVERED_IN_WAREHOUSE": "Waiting for Weight Confirmation",
			"APPROVED_WEIGHT": "Weight Confirmed",
			"PENDING_ANALYSIS": "Pending Analysis",
			"LAB_ANALYSIS_RESULT_IS_READY": "Analysis Result Ready",
			"CANCELED_WAREHOUSING": "Warehousing Canceled",
			"PARTIALLY_CANCELED": "Partially Canceled",
			"CONVERTED_TO_STOCKS": "Converted to Stocks",
			"RESULT_MISMATCH": "Mismatch between lab results and declared symbol"
		},
		"releaseFromShed": {
			"reqQuantity": "Requested Qty",
			"deliveredQuantity": "Delivered Qty"
		}
	},
	"cancelGoodsToWarehouse": {
		"releasedDate": "Warehouse Exit Time",
		"statusList": {
			"PENDING": "Initial Reg",
			"REQ_RELEASE": "Warehousing Req",
			"ASSIGNED_DELIVER_TIME": "Time Assigned",
			"LOADING_IN_WAREHOUSE": "Loading",
			"DELIVERED": "Delivered at Warehouse"
		}
	},
	"canceledGoodsList": {
		"updateDriverInfo": "Update Driver Info"
	},
	"updateDriverInfo": {
		"submit": "Update Driver Info",
		"error": "Error",
		"errorMessage": "Error updating driver info",
		"validationError": "Validation Error",
		"validationErrorMessage": "Please fill all required fields correctly"
	},
	"stockDetails": {
		"loading": "Loading data...",
		"error": "Error retrieving data.",
		"empty": "No data to display.",
		"currentPrice": "Current Price",
		"dailyVolume": "Daily Volume",
		"dayHigh": "Daily High",
		"dayLow": "Daily Low",
		"yearHigh": "Yearly High",
		"yearLow": "Yearly Low"
	},
	"stockWalletDetails": {
		"title": "Symbol History",
		"loading": "Loading transactions...",
		"error": "Error loading transactions",
		"empty": "No transactions found",
		"transactionType": "Transaction Type",
		"paymentStatus": "Payment Status",
		"amount": "Amount",
		"coefficient": "Coefficient",
		"dateOfTransaction": "Transaction Date",
		"description": "Description",
		"traceCode": "Trace Code",
		"summary": {
			"totalBuy": "Total Buy",
			"totalSell": "Total Sell",
			"totalFees": "Total Fees",
			"pendingTransactions": "Pending Transactions",
			"netBalance": "Net Balance"
		},
		"transactionTypes": {
			"BUY": "Buy",
			"SELL": "Sell",
			"FEE": "Fee",
			"GOODS_TO_WAREHOUSE": "Inbound Warehouse",
			"RELEASE_FROM_WAREHOUSE": "Outbound Warehouse"
		},
		"paymentStatuses": {
			"ACCEPTED": "Accepted",
			"BLOCKED": "Blocked"
		},
		"filters": {
			"symbol": "Symbol",
			"transactionType": "Transaction Type",
			"paymentStatus": "Payment Status",
			"amountRange": "Amount Range",
			"search": "Search",
			"fromAmount": "From Amount",
			"toAmount": "To Amount",
			"allTypes": "All Types",
			"allStatuses": "All Statuses",
			"clearFilters": "Clear Filters",
			"applyFilters": "Apply Filters"
		},
		"timeline": {
			"today": "Today",
			"yesterday": "Yesterday",
			"daysAgo": "{{count}} days ago",
			"hoursAgo": "{{count}} hours ago",
			"minutesAgo": "{{count}} minutes ago"
		},
		"loadMore": "Show More",
		"remaining": "Remaining"
	},
	"ratioHelp": "This chart shows volume distribution in buy and sell orders as a percentage.",
	"sendPhoto": "Send Photo",
	"tour": {
		"help": "Help",
		"prevBtnTitle": "Prev",
		"nextBtnTitle": "Next",
		"endBtnTitle": "End",
		"welcome_t": "System Guide",
		"welcome_c": "Hello and welcome. Follow the steps with me to explain the system features.",
		"order0_t": "Limit Order",
		"order0_c": "Order executes at your set price or better. Speed depends on the set price.",
		"order1_t": "Market Order",
		"order1_c": "Order executes instantly at best market price. Final price may vary due to volatility.",
		"ratioHelp_t": "Volume Distribution Chart",
		"ratioHelp_c": "This chart shows volume distribution in buy and sell orders as a percentage.",
		"chartHelp_t": "Price Chart",
		"chartHelp_c": "Use this chart to view prices and buy/sell volumes over different timeframes."
	},
	"referralTimeLine": {
		"step1": "Share your exclusive link with friends.",
		"step2": "Your friends register on TadaMarket and trade.",
		"step3": "After the first trade, both you and your friends receive rewards.",
		"submitted": "Invitation code submitted successfully",
		"not_submitted": "Invitation code not submitted"
	},
	"CONNECTION": {
		"CONNECTED": "Connected",
		"ATTEMPTING": "Connecting...",
		"DISCONNECTED": "Connection lost",
		"NAME": "Connection Status"
	},
	"cards": {
		"title": "Card Management",
		"card": "Card",
		"addNew": "Add New Card",
		"cardNumber": "Card Number",
		"bankName": "Bank Name",
		"status": "Status",
		"default": "Default",
		"secondary": "Secondary",
		"setDefault": "Set as Default",
		"delete": "Delete",
		"addCard": "Add Card",
		"noCardsFound": "No cards found",
		"confirmSetDefault": "Are you sure you want to set this card as default?",
		"addCardDescription": "Add a new payment card to your account",
		"cardNumberPlaceholder": "Enter 16-digit card number",
		"cardNumberRequired": "Card number is required and must be 16 digits",
		"invalidCard": "Invalid card number.",
		"securityNotice": "Security Notice",
		"securityNoticeDescription": "Your card data is stored securely and encrypted. We never store your full card number.",
		"defaultBank": "Bank",
		"actions": "Actions"
	},
	"userProfileCompletion": {
		"title": "Complete Profile",
		"subtitle": "Please complete your information",
		"steps": {
			"basicInfo": "Basic Info",
			"userType": "User Type",
			"bankCardInfo": "Bank Card Info"
		},
		"basicInfoSection": {
			"title": "Basic Info",
			"description": "If information is incorrect, use the edit button at the end of each field.",
			"birthDate": "Birth Date",
			"mobile": "Mobile Number",
			"nationalId": "National ID",
			"continue": "Continue"
		},
		"addCardSection": {
			"cardAdded": "Card added successfully"
		},
		"userTypeSection": {
			"title": "Switch to Legal Account",
			"description": "If you wish to switch to a legal (corporate) account, click the button below.",
			"switchToLegal": "Request Switch to Legal Account",
			"requestPending": "Your request to switch to a legal account has been submitted. Please wait for admin approval. You cannot proceed until approved.",
			"requestSuccess": "Your request to switch to a legal account was sent successfully.",
			"requestError": "An error occurred while sending your request."
		}
	},
	"dialogs": {
		"legal": {
			"title": "Request Legal Account Switch",
			"companyName": "Company Name",
			"companyNationalId": "Company National ID",
			"companyRegNum": "Registration Number",
			"companyPostalCode": "Company Postal Code",
			"companyAddress": "Company Address",
			"cancel": "Cancel",
			"submit": "Send Request",
			"sending": "Sending...",
			"economicCode": "Economic Code"
		},
		"legalUserStatus": {
			"title": "Change Legal User Status",
			"userLabel": "User",
			"statusLabel": "New Status",
			"statusPlaceholder": "Select Status",
			"cancel": "Cancel",
			"update": "Update Status",
			"updateSuccess": "User status updated successfully"
		},
		"phone": {
			"title": "Change Mobile Number",
			"newPhoneLabel": "New Mobile Number",
			"placeholder": "09123456789",
			"sendOtp": "Send Code",
			"sendingOtp": "Sending...",
			"otpLabel": "Enter Verification Code",
			"verifyOtp": "Verify Code",
			"verifyingOtp": "Verifying..."
		},
		"identity": {
			"title": "Change National ID",
			"newIdentityLabel": "New National ID",
			"placeholder": "1234567890",
			"cancel": "Cancel",
			"update": "Update",
			"updating": "Updating..."
		},
		"releaseGoodsFromWarehouse": {
			"select": "Please select your goods for exit first"
		}
	},
	"approval-wait-list": {
		"title": "Role Change Requests",
		"loading": "Loading...",
		"empty": "No requests found.",
		"messages": {
			"loadError": "Failed to load data"
		},
		"form": {
			"name": "User",
			"role": "Requested Role"
		},
		"filters": {
			"status": "Status",
			"role": "Role"
		},
		"table": {
			"status": "Status",
			"date": "Date",
			"actions": "Actions"
		},
		"details": {
			"title": "Request Details",
			"feedback": "Admin Feedback",
			"files": "Attached Documents",
			"document": "ID Document",
			"certificate": "Certificate",
			"license": "License",
			"feedbackPlaceholder": "Enter feedback for the user if needed...",
			"notReviewable": "This request is not in a reviewable state",
			"confirmApprove": "Are you sure you want to approve and assign this role to the user?"
		},
		"actions": {
			"startReview": "Start Review",
			"requestEdit": "Request Edit",
			"reject": "Reject",
			"approve": "Approve"
		},
		"statuses": {
			"draft": "Draft",
			"submitted": "Submitted",
			"under_review": "Under Review",
			"needs_edit": "Needs Edit",
			"approved": "Approved",
			"rejected": "Rejected"
		},
		"roles": {
			"clinic_admin": "Clinic Admin",
			"salon_admin": "Salon Admin",
			"trainer_user": "Trainer",
			"trainee_user": "Trainee",
			"seller_user": "Seller"
		},
		"validation": {
			"feedbackRequired": "Feedback is required for this action."
		}
	},
	"requestRole": {
		"title": "Request Role Change",
		"subtitle": "Select your desired role and upload the required documents.",
		"selectRole": "Select Role",
		"documents": "Documents",
		"requiredDocs": "Required Documents",
		"activeAccesses": "Active Access After Approval",
		"uploadWarning": "To submit a request for verification, it is mandatory to upload all documents. If the documents are incomplete, the request cannot be submitted.",
		"noDocsRequired": "No documents required",
		"noAvailableRoles": "You currently have an active request for all roles or already hold the available roles.",
		"selectSubType": "Registrant Type",
		"additionalInfo": "Additional Information",
		"documentsHint": "Upload all required documents for your selected role.",
		"adminNote": "Admin note",
		"needsEditTitle": "Your request needs edits",
		"needsEditHint": "Please fix the issues mentioned and resubmit. The role cannot be changed at this stage.",
		"roleLocked": "The role cannot be changed at this stage.",
		"upload": "Upload",
		"uploaded": "Uploaded",
		"saveDraft": "Save Draft",
		"submit": "Submit for Review",
		"edit": "Edit",
		"noIdentity": "Please complete your identity information first.",
		"goToProfile": "Complete Information",
		"myRequests": "My Requests",
		"files": {
			"nationalId": "Upload National ID Card",
			"spaceSignPhoto": "Upload Sign or Entrance Photo",
			"spaceImages": "Upload Real Images of the Space",
			"businessLicense": "Upload Business License",
			"clinicLicense": "Upload Clinic License",
			"medicalCertificate": "Upload Medical System Certificate",
			"resume": "Upload Resume / Portfolio / Course Certificate",
			"courseSyllabus": "Upload Course Syllabus",
			"schoolLicense": "Upload School or Institute License",
			"ownershipProof": "Upload Invoice or Proof of Ownership",
			"healthCertificate": "Upload Health Certificate or Product Authenticity",
			"productImages": "Upload Real Product Images",
			"realEstateLicense": "Upload Real Estate License or Permit",
			"publicationPermit": "Upload Document Authorizing Ad Publication"
		},
		"statuses": {
			"draft": "Awaiting Documents",
			"submitted": "Awaiting Review",
			"under_review": "Under Review",
			"needs_edit": "Needs Correction",
			"approved": "Approved",
			"rejected": "Rejected"
		},
		"roles": {
			"user": "Regular User",
			"beauty_artist": "Beauty Artist / Student",
			"salon_admin": "Salon Manager / Space Owner",
			"clinic_admin": "Doctor / Clinic Manager",
			"instructor": "Teacher / School",
			"trainer_user": "Teacher / School",
			"trainee_user": "Beauty Artist / Student",
			"seller_user": "Beauty Equipment or Material Seller"
		},
		"subTypes": {
			"salonOwner": "Salon Manager / Space Owner",
			"realEstateExpert": "Real Estate Expert",
			"student": "Student",
			"artist": "Beauty Artist",
			"teacher": "Teacher",
			"school": "School / Institute",
			"doctor": "Doctor",
			"clinicManager": "Clinic Manager",
			"equipment": "Equipment",
			"material": "Material / Supplies"
		},
		"textFields": {
			"lineOfWork": "Specialty / Field of Work",
			"medicalSystemNumber": "Medical System Number",
			"officeAddress": "Business Address",
			"officeContactNumber": "Business Contact Number",
			"productInfo": "Product Info (Serial, Warranty, Production & Expiry Dates)"
		},
		"accesses": {
			"user": {
				"viewAds": "View ads",
				"searchFilter": "Search, filter, compare",
				"compare": "Compare ads",
				"saveInterests": "Save interests",
				"viewCoursesProfiles": "View courses and profiles",
				"viewContactInfo": "View advertiser contact information",
				"contactAdvertiser": "Contact advertiser and send messages"
			},
			"salonAdmin": {
				"registerSpaceAds": "Register rental ads (chair, room, bed, table, workspace, full salon, clinic)",
				"manageAds": "Manage, edit, delete, extend, ladder, urgent and special ads",
				"viewMessages": "View messages",
				"viewStats": "View visit statistics",
				"contact": "Contact and save",
				"payments": "Payments"
			},
			"traineeUser": {
				"viewCompareAds": "View and compare ads",
				"viewContactInfo": "View contact information",
				"sendMessages": "Send messages",
				"viewCourses": "View courses",
				"registerCompanion": "Register companion request",
				"registerRentalAd": "Register rental or companion ad",
				"sellPersonalEquipment": "Sell personal or used equipment",
				"registerAuction": "Register auction for personal equipment",
				"manageAds": "Manage your own ads",
				"purchaseServices": "Purchase ladder/urgent/special"
			},
			"trainerUser": {
				"registerCourses": "Register in-person, online or combined courses",
				"manageCourses": "Manage, edit, delete and extend courses",
				"viewStudentMessages": "View student messages and requests",
				"viewStats": "View visit and registration statistics",
				"purchaseServices": "Purchase ads, ladder, urgent and special services"
			},
			"clinicAdmin": {
				"registerSpaceAds": "Register clinical space ads",
				"registerCooperationAds": "Register specialized cooperation ads",
				"introduceServices": "Introduce displayable services",
				"manageAds": "Manage ads",
				"receiveMessages": "Receive messages",
				"viewStats": "View statistics",
				"purchasePromotions": "Purchase ad promotion services",
				"registerCourses": "Register specialized courses or events (if instructor role)"
			},
			"sellerUser": {
				"registerEquipmentAds": "Register new and used equipment sale ads",
				"registerMaterialAds": "Register material sale ads",
				"registerAuctionAds": "Register equipment auction ads (if auction is active)",
				"manageAds": "Manage ads",
				"receiveMessages": "Receive messages",
				"viewStats": "View statistics",
				"purchaseServices": "Purchase ladder/urgent/special services"
			}
		},
		"draftSaved": "Draft saved.",
		"submitSuccess": "Your request was submitted successfully and will be reviewed after verification by the Beauty Boss team.",
		"saveError": "Failed to save the request.",
		"uploadError": "Failed to upload file.",
		"shahkarFailed": "National-code verification failed. Please check your national code and mobile number in your profile."
	},
	"chat": {
		"title": "Messages",
		"inbox": "Inbox",
		"conversation": "Conversation",
		"send": "Send",
		"placeholder": "Type a message..."
	},
	"optimus": {
		"startsWith": "Starts with",
		"contains": "Contains",
		"notContains": "Not contains",
		"endsWith": "Ends with",
		"equals": "Equals",
		"notEquals": "Not equals",
		"noFilter": "No Filter",
		"lt": "Less than",
		"lte": "Less than or equal to",
		"gt": "Greater than",
		"gte": "Greater than or equal to",
		"is": "Is",
		"isNot": "Is not",
		"before": "Before",
		"after": "After",
		"dateIs": "Date is",
		"dateIsNot": "Date is not",
		"dateBefore": "Date is before",
		"dateAfter": "Date is after",
		"clear": "Clear",
		"apply": "Apply",
		"matchAll": "Match All",
		"matchAny": "Match Any",
		"addRule": "Add Rule",
		"removeRule": "Remove Rule",
		"accept": "Yes",
		"reject": "No",
		"choose": "Choose",
		"upload": "Upload",
		"cancel": "Cancel",
		"completed": "Completed",
		"fileSizeTypes": [
			"B",
			"KB",
			"MB",
			"GB",
			"TB"
		],
		"dayNames": [
			"Sunday",
			"Monday",
			"Tuesday",
			"Wednesday",
			"Thursday",
			"Friday",
			"Saturday"
		],
		"dayNamesShort": [
			"Sun",
			"Mon",
			"Tue",
			"Wed",
			"Thu",
			"Fri",
			"Sat"
		],
		"dayNamesMin": [
			"Su",
			"Mo",
			"Tu",
			"We",
			"Th",
			"Fr",
			"Sa"
		],
		"monthNames": [
			"January",
			"February",
			"March",
			"April",
			"May",
			"June",
			"July",
			"August",
			"September",
			"October",
			"November",
			"December"
		],
		"monthNamesShort": [
			"Jan",
			"Feb",
			"Mar",
			"Apr",
			"May",
			"Jun",
			"Jul",
			"Aug",
			"Sep",
			"Oct",
			"Nov",
			"Dec"
		],
		"dateFormat": "mm/dd/yy",
		"firstDayOfWeek": 0,
		"today": "Today",
		"weekHeader": "Wk",
		"weak": "Weak",
		"medium": "Medium",
		"strong": "Strong",
		"passwordPrompt": "Enter a password",
		"emptyMessage": "No results found",
		"emptyFilterMessage": "No results found",
		"emptySearchMessage": "No results found",
		"emptySelectionMessage": "No selected item",
		"selectionMessage": "{0} items selected",
		"searchMessage": "{0} results are available",
		"fileChosenMessage": "{0} files selected",
		"noFileChosenMessage": "No file chosen",
		"pending": "Pending",
		"chooseYear": "Choose Year",
		"chooseMonth": "Choose Month",
		"chooseDate": "Choose Date",
		"prevDecade": "Previous Decade",
		"nextDecade": "Next Decade",
		"prevYear": "Previous Year",
		"nextYear": "Next Year",
		"prevMonth": "Previous Month",
		"nextMonth": "Next Month",
		"prevHour": "Previous Hour",
		"nextHour": "Next Hour",
		"prevMinute": "Previous Minute",
		"nextMinute": "Next Minute",
		"prevSecond": "Previous Second",
		"nextSecond": "Next Second",
		"am": "AM",
		"pm": "PM",
		"aria": {
			"trueLabel": "True",
			"falseLabel": "False",
			"nullLabel": "Not Selected",
			"star": "{star} star",
			"stars": "{star} stars",
			"selectAll": "All items selected",
			"unselectAll": "All items unselected",
			"close": "Close",
			"previous": "Previous",
			"next": "Next",
			"navigation": "Navigation",
			"scrollTop": "Scroll Top",
			"moveTop": "Move Top",
			"moveUp": "Move Up",
			"moveDown": "Move Down",
			"moveBottom": "Move Bottom",
			"moveToTarget": "Move to Target",
			"moveToSource": "Move to Source",
			"moveAllToTarget": "Move All to Target",
			"moveAllToSource": "Move All to Source",
			"pageLabel": "Page {page}",
			"firstPageLabel": "First Page",
			"lastPageLabel": "Last Page",
			"nextPageLabel": "Next Page",
			"prevPageLabel": "Previous Page",
			"previousPageLabel": "Previous Page",
			"rowsPerPageLabel": "Rows per page",
			"jumpToPageDropdownLabel": "Jump to Page Dropdown",
			"jumpToPageInputLabel": "Jump to Page Input",
			"selectRow": "Select Row",
			"unselectRow": "Unselect Row",
			"expandRow": "Expand Row",
			"collapseRow": "Collapse Row",
			"showFilterMenu": "Show Filter Menu",
			"hideFilterMenu": "Hide Filter Menu",
			"filterOperator": "Filter Operator",
			"filterConstraint": "Filter Constraint",
			"editRow": "Edit Row",
			"saveEdit": "Save Edit",
			"cancelEdit": "Cancel Edit",
			"listView": "List View",
			"gridView": "Grid View",
			"slide": "Slide",
			"slideNumber": "Slide {slideNumber}",
			"zoomImage": "Zoom Image",
			"zoomIn": "Zoom In",
			"zoomOut": "Zoom Out",
			"rotateRight": "Rotate Right",
			"rotateLeft": "Rotate Left",
			"listLabel": "Options List",
			"selectColor": "Select a color",
			"removeLabel": "Remove",
			"browseFiles": "Browse Files",
			"maximizeLabel": "Maximize",
			"minimizeLabel": "Minimize"
		}
	}
}
